import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, MenuItem
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import _, { map, set } from 'lodash';
import { LoadingComponent } from 'src/utils/newLoader';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import TablePagination from '@material-ui/core/TablePagination';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecord: {
        backgroundColor: "green",
    },
}));

const getPageMargins = () => {
    return `@media print {
            @page {
            size: A4 !important;
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
};

const screenCode = 'ADVANCEPAYMENTREPORT';

export default function AdvancePaymentReport(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    const componentRef = useRef();
    const [title, setTitle] = useState("Advance Payment Report");
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [applicableDate, setApplicableDate] = useState(new Date());
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null)
    const classes = useStyles();
    const [GroupList, setGroupList] = useState([]);
    const [FactoryList, setFactoryList] = useState([]);
    const [mappingData, setMappingData] = useState([]);
    const [RouteList, setRouteList] = useState([])
    const [totalApprovedAmount, setTotalApprovedAmount] = useState(0);
    const [advancePaymentDetails, setAdvancePaymentDetails] = useState({
        groupID: 0,
        factoryID: 0,
        routeID: 0,
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: "0",
        factoryName: "0",
        routeName: "0",
        startDate: '',
        endDate: ''
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
    });
    const [limit, setLimit] = useState(5);
    const [page, setPage] = useState(0)
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const monthName = monthNames[applicableDate.getMonth()];

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(getPermission());
        trackPromise(getGroupsForDropdown());
        setPage(0);
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown());
            setAdvancePaymentDetails({
                ...advancePaymentDetails,
                factoryID: 0,
                routeID: 0,
            });
    }, [advancePaymentDetails.groupID]);

    useEffect(() => {
        trackPromise(
            getRouteForDropdown());
            setAdvancePaymentDetails({
                ...advancePaymentDetails,
                routeID: 0,
            });
    }, [advancePaymentDetails.factoryID]);

    useEffect(() => {
        if (applicableDate) {
            setSelectedMonth(applicableDate.getMonth() + 1);
            setSelectedYear(applicableDate.getFullYear());
        }
    }, [applicableDate]);

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWADVANCEPAYMENTREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setAdvancePaymentDetails({
            ...advancePaymentDetails,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        })
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroupList(groups);
    }

    async function getFactoriesForDropdown() {
        const factories = await services.getFactoryByGroupID(advancePaymentDetails.groupID);
        setFactoryList(factories);
    }

    async function getRouteForDropdown() {
        const routes = await services.getRoutesForDropDown(advancePaymentDetails.factoryID);
        setRouteList(routes);
    }

    async function GetDetails() {
        let model = {
            groupID: parseInt(advancePaymentDetails.groupID),
            factoryID: parseInt(advancePaymentDetails.factoryID),
            routeID: parseInt(advancePaymentDetails.routeID),
            fromDate: moment(startDate.toString()).format().split('T')[0],
            toDate: moment(endDate.toString()).format().split('T')[0],
            applicableMonth: selectedMonth,
            applicableYear: selectedYear,
        }
        getSelectedDropdownValuesForReport(model);
        const response = await services.GetAdvancePaymentReportDetails(model);
        if (response.statusCode == "Success" && response.data != null) {
            setMappingData(response.data);
            calculateTotalApprovedAmount(response.data);
            if (response.data.length == 0) {
                alert.error("No records to display");
            }
        }
        else {
            alert.error(response.message);
        }
    }

    async function createDataForExcelTransaction(array) {
        let res = [];

        if (array && array.length > 0) {
            array.forEach(group => {
                group.records.forEach(rec => {
                    res.push({
                        'Route': group.routeName,
                        'Date': new Date(rec.issuingDate).toLocaleDateString('en-CA'),
                        'Code': rec.referenceNumber,
                        'Reg No': rec.registrationNumber,
                        'Customer': rec.fullName,
                        'Amount': parseFloat(rec.approvedAmount)
                    });
                });

                res.push({
                    'Route': '',
                    'Date': '',
                    'Code': '',
                    'Reg No': '',
                    'Customer': '',
                    'Amount': ''
                });

                res.push({
                    'Route': `Route Total: (${group.records.length})`,
                    'Date': '',
                    'Code': '',
                    'Reg No': '',
                    'Customer': '',
                    'Amount': parseFloat(group.totalApprovedAmount)
                });

                res.push({
                    'Route': '',
                    'Date': '',
                    'Code': '',
                    'Reg No': '',
                    'Customer': '',
                    'Amount': ''
                });
            });

            res.push({
                'Route': 'Grand Total:',
                'Date': '',
                'Code': '',
                'Reg No': '',
                'Customer': '',
                'Amount': parseFloat(totalApprovedAmount)
            });
            res.push([]);
            var vr = {
                'Route': 'Group- ' + selectedSearchValues.groupName,
                'Date': 'Factory - ' + selectedSearchValues.factoryName
            };
            res.push(vr);
            var vr = {
                'Route': 'From Date - ' + selectedSearchValues.startDate,
                'Date': ' To Date - ' + selectedSearchValues.endDate,
            };
            res.push(vr);
            var vr = {
                'Route': 'Applicable Month - ' + monthName,
                'Date': selectedSearchValues.routeName ? 'Route -' + selectedSearchValues.routeName : 'Route -' + 'All Routes'
            };
            res.push(vr);
        }
        return res;
    }

    async function createFile() {
        const file = await createDataForExcelTransaction(mappingData);
        const settings = {
            sheetName: 'Advance Payment Report',
            fileName: 'Advance Payment Report - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' ' + selectedSearchValues.startDate + ' - ' + selectedSearchValues.endDate + ' ' + "Applicable Month - " + monthName,
            writeOptions: {}
        };
        const keys = Object.keys(file[0] || {});
        const headers = keys.map(key => ({ label: key, value: key }));
        const dataA = [
            {
                sheet: settings.sheetName,
                columns: headers,
                content: file
            }
        ];
        xlsx(dataA, settings);
    }

    function calculateTotalApprovedAmount(data) {
        const totalApproved = data.reduce((acc, item) => acc + (parseFloat(item.totalApprovedAmount) || 0), 0);
        setTotalApprovedAmount(totalApproved);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        if (target.name === 'groupID') {
            setAdvancePaymentDetails({
                ...advancePaymentDetails,
                [e.target.name]: value,
                factoryID: 0
            });
        } else {
            setAdvancePaymentDetails({
                ...advancePaymentDetails,
                [e.target.name]: value
            });
        }
        setMappingData([]);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        var fromDate = moment(searchForm.fromDate.toString()).format().split('T')[0]
        var toDate = moment(searchForm.toDate.toString()).format().split('T')[0]
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: GroupList[searchForm.groupID],
            factoryName: FactoryList[searchForm.factoryID],
            routeName: RouteList[searchForm.routeID],
            startDate: [fromDate],
            endDate: [toDate]
        })
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
            </Grid>
        )
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: advancePaymentDetails.groupID,
                            factoryID: advancePaymentDetails.factoryID,
                            routeID: advancePaymentDetails.routeID,
                            startDate: startDate,
                            endDate: endDate
                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                                startDate: Yup.date().required('From Date is Required'),
                                endDate: Yup.date().required('To Date is Required'),
                            })
                        }
                        onSubmit={() => trackPromise(GetDetails())}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader title={cardTitle(title)} />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent>
                                                <Grid container spacing={3}>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            fullWidth
                                                            helperText={touched.groupID && errors.groupID}
                                                            name="groupID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={advancePaymentDetails.groupID}
                                                            variant="outlined"
                                                            id="groupID"
                                                            disabled={!permissionList.isGroupFilterEnabled}
                                                            size='small'
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(GroupList)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            name="factoryID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={advancePaymentDetails.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            disabled={!permissionList.isFactoryFilterEnabled}
                                                            size='small'
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(FactoryList)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="routeID">
                                                            Route
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.routeID && errors.routeID)}
                                                            fullWidth
                                                            helperText={touched.routeID && errors.routeID}
                                                            name="routeID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={advancePaymentDetails.routeID}
                                                            variant="outlined"
                                                            id="routeID"
                                                            size='small'
                                                        >
                                                            <MenuItem value="0">--Select Route--</MenuItem>
                                                            {generateDropDownMenu(RouteList)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                variant="inline"
                                                                openTo="month"
                                                                views={["year", "month"]}
                                                                label="Applicable Month *"
                                                                helperText="Select applicable month"
                                                                value={applicableDate}
                                                                onChange={(e) => {
                                                                    setApplicableDate(e)
                                                                    setMappingData([])
                                                                }}
                                                                maxDate={new Date()}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>From Date *</InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                name='startDate'
                                                                id='startDate'
                                                                value={startDate}
                                                                maxDate={new Date()}
                                                                onChange={(e) => {
                                                                    setStartDate(e)
                                                                    setMappingData([])
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                autoOk
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>

                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>To Date *</InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                name='startDate'
                                                                id='startDate'
                                                                value={endDate}
                                                                onChange={(e) => {
                                                                    setEndDate(e)
                                                                    setMappingData([])
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                autoOk
                                                                maxDate={new Date()}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                </Grid>
                                                <Box display="flex" flexDirection="row-reverse" p={2} >
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                        size='small'
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>
                                            </CardContent>
                                            {mappingData.length > 0 ?
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <TableContainer component={Paper} style={{ maxHeight: "550px", overflow: "auto",}}>
                                                        <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="center" style={{ border: "1px solid black" }}>Date</TableCell>
                                                                    <TableCell align="center" style={{ border: "1px solid black" }}>Code</TableCell>
                                                                    <TableCell align="center" style={{ border: "1px solid black" }}>Reg No</TableCell>
                                                                    <TableCell align="center" style={{ border: "1px solid black" }}>Customer</TableCell>
                                                                    <TableCell align="center" style={{ border: "1px solid black" }}>Amount</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody style={{ paddingBottom: "53px" }}>
                                                                {mappingData.slice(page * limit, page * limit + limit).map((group, index) => (
                                                                    <React.Fragment key={index}>
                                                                        <TableRow>
                                                                            <TableCell colSpan={5} align="center" border="1px solid black" style={{ backgroundColor: "#B0C4DE", fontWeight: "bold", border: "1px solid black" }}>
                                                                                {group.routeName}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                        {group.records.map((rec, idx) => (
                                                                            <TableRow key={`${index}-${idx}`}>
                                                                                <TableCell style={{ border: "1px solid black" }}>{new Date(rec.issuingDate).toLocaleDateString('en-CA')}</TableCell>
                                                                                <TableCell style={{ border: "1px solid black" }}>{rec.referenceNumber}</TableCell>
                                                                                <TableCell style={{ border: "1px solid black" }}>{rec.registrationNumber}</TableCell>
                                                                                <TableCell style={{ border: "1px solid black" }}>{rec.fullName}</TableCell>
                                                                                <TableCell align="right" style={{ border: "1px solid black" }}>{rec.approvedAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                        <TableRow>
                                                                            <TableCell colSpan={4} align="left" style={{ border: "1px solid black" , position: "sticky", zIndex: 1 }}><b>Route Total: ({group.records.length})</b></TableCell>
                                                                            <TableCell align="right" style={{ border: "1px solid black", position: "sticky", zIndex: 1 }}><b>{group.totalApprovedAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                                                                        </TableRow>
                                                                    </React.Fragment>
                                                                ))
                                                                }
                                                                <TableRow>
                                                                    <TableCell colSpan={4} align="left" style={{ border: "1px solid black" }}><b>Grand Total:</b></TableCell>
                                                                    <TableCell align="right" style={{ border: "1px solid black" }}><b>{totalApprovedAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</b></TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                        <TablePagination
                                                            component="div"
                                                            count={mappingData.length}
                                                            page={page}
                                                            onChangePage={handlePageChange}
                                                            rowsPerPage={limit}
                                                            onChangeRowsPerPage={handleLimitChange}
                                                            rowsPerPageOptions={[5, 10, 25, 50]}
                                                        />
                                                    </TableContainer>
                                                </Box>
                                                : null}
                                            {mappingData.length > 0 ?
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        id="btnRecord"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem' }}
                                                        className={classes.colorRecord}
                                                        onClick={createFile}
                                                    >
                                                        EXCEL
                                                    </Button>
                                                    <div>&nbsp;</div>
                                                    <ReactToPrint
                                                        documentTitle={'Advance Payment Report - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' ' 
                                                            + selectedSearchValues.startDate + ' - ' + selectedSearchValues.endDate + ' ' + "Applicable Month - " + monthName}
                                                        trigger={() => <Button
                                                            color="primary"
                                                            id="btnCancel"
                                                            variant="contained"
                                                            style={{ marginRight: '1rem' }}
                                                            className={classes.colorCancel}
                                                        >
                                                            PDF
                                                        </Button>}
                                                        content={() => componentRef.current}
                                                        pageStyle={getPageMargins()}
                                                    />
                                                    <div hidden={true}>
                                                        <CreatePDF
                                                            ref={componentRef}
                                                            mappingData={mappingData}
                                                            SearchData={selectedSearchValues}
                                                            applicableDate={monthName}
                                                            totalApprovedAmount={totalApprovedAmount}
                                                        />
                                                    </div>
                                                </Box> : null}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page>
        </Fragment>
    );
}

